/* sentry file imported first, will init sentry
https://docs.sentry.io/platforms/javascript/guides/react/#install
*/
import './helper/sentry'

// React 19 removed the legacy ReactDOM.render that antd's static
// message/notification/Modal APIs render through. This patch rewires them
// onto react-dom/client. Must load before the first static call.
import '@ant-design/v5-patch-for-react-19'
import { ApolloProvider } from '@apollo/client/react'
import { ErrorBoundary } from '@sentry/react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { getApolloClient, initApolloClient } from './apollo'
import i18n from './i18n/i18n'
import Routes from './routes'

/*
 * init apollo
 */
initApolloClient()

const client = getApolloClient()

const container = document.querySelector('.main')
if (!container) {
  throw new Error('Root container ".main" not found')
}

createRoot(container).render(
  <ErrorBoundary>
    <I18nextProvider i18n={i18n}>
      <ApolloProvider client={client}>
        <Routes />
      </ApolloProvider>
    </I18nextProvider>
  </ErrorBoundary>
)
